import {WorkspaceModel, WorkspaceModelType} from '@stores/WorkspaceStore';


import type {RootStoreModel} from "@stores/RootStore";
import type {DataSourceManager} from "@stores/dataSources/DataSourceManager";
import {Workspace} from "../../API";


import {workspaceToWorkspaceMSTSnapshotIn} from "@stores/convertors/workspaceToWorkspaceMSTSnapshotIn";
import {isAlive} from "mobx-state-tree";
import {when} from "mobx";
import {itemToItemMSTSnapshotIn} from "@stores/convertors/itemToItemMSTSnapshotIn";
import {syncItemUpdate} from "../../sync/itemSync";


let previouslyActiveWorkspace: WorkspaceModelType | null = null;

export function selectWorkspace(rootStore: RootStoreModel, workspace: WorkspaceModelType | null) {
    if (workspace === previouslyActiveWorkspace) {
        return;
    }

    const view = rootStore.view;
    rootStore.setRightMenu('');
    previouslyActiveWorkspace = workspace;
    view.setWorkspace(workspace);
}

export async function selectWorkspaceFromPlain(rootStore: RootStoreModel, dsManager: DataSourceManager, workspaceServer: Workspace | null) {
    if (workspaceServer === null) {
        selectWorkspace(rootStore, null);
        return;
    }

    const workspaceMST = WorkspaceModel.create(workspaceToWorkspaceMSTSnapshotIn(workspaceServer));
    selectWorkspace(
        rootStore,
        workspaceMST
    )

    const itemsDataSource = dsManager.getItemsDataSource(workspaceServer.id);
    if (!itemsDataSource.isInitialized) {
        await itemsDataSource.initialLoad();
    }

    if (isAlive(workspaceMST)) {
        workspaceMST.setItems(itemsDataSource.allRows);

        // When initial load came from cache, DataSource continues background refresh.
        // Reconcile MST items after refresh fully completes to avoid stale UI until next reload.
        if (itemsDataSource.isShowingCachedData) {
            void when(
                () => !itemsDataSource.isShowingCachedData && !itemsDataSource.isRefreshing,
                () => {
                    if (!isAlive(workspaceMST)) {
                        return;
                    }
                    if (rootStore.view.workspace?.id !== workspaceMST.id) {
                        return;
                    }

                    for (const serverItem of itemsDataSource.allRows) {
                        syncItemUpdate(workspaceMST, serverItem);
                    }

                    workspaceMST.syncItems(itemsDataSource.allRows.map(itemToItemMSTSnapshotIn));
                }
            );
        }
    }
    return workspaceMST;
}
